import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_SALARY, ADD_SALARY_FAILED, ADD_SALARY_REVISION, ADD_SALARY_REVISION_FAILED, ADD_SALARY_REVISION_SUCCESS, ADD_SALARY_SUCCESS, SALARY, SALARY_FAILED, SALARY_HISTORY, SALARY_HISTORY_FAILED, SALARY_HISTORY_SUCCESS, SALARY_SLIP, SALARY_SLIP_FAILED, SALARY_SLIP_SUCCESS, SALARY_SUCCESS, UPDATE_SALARY, UPDATE_SALARY_FAILED, UPDATE_SALARY_SLIP, UPDATE_SALARY_SLIP_FAILED, UPDATE_SALARY_SLIP_SUCCESS, UPDATE_SALARY_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"

export const generateSalarySlip = (paylod) => async (dispatch) => {
  dispatch({
    type: SALARY,
  });
  try {
    let response = await api(`salary/generate/salarySlip`, "post", paylod, getAuthHeader());
    dispatch({
      type: SALARY_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Salary details error ====>", error);
    return dispatch({
      type: SALARY_FAILED,
      payload: error?.message,
      message: error?.response?.data?.message,
      status: error?.status
    });
  }
};

export const userdetailsSalarySlip = (paylod) => async (dispatch) => {
  dispatch({
    type: SALARY,
  });
  try {
    let response = await api(`salary/user/salarySlip`, "get", getAuthHeader());
    console.log("userdetailsSalarySlip: ",response)
    dispatch({
      type: SALARY_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Salary details error ====>", error);
    return dispatch({
      type: SALARY_FAILED,
      payload: error?.message,
      message: error?.response?.data?.message,
      status: error?.status
    });
  }
};

export const getSalaryDetails = () => async (dispatch) => {
  dispatch({
    type: SALARY,
  });
  try {
    let response = await api(`salary/getSalaryDetails`, "get", {}, getAuthHeader());
    dispatch({
      type: SALARY_SUCCESS,
      payload: response?.data,
    });
    console.log("response", response)
    return response;
  } catch (error) {
    console.log("while fetching Salary details error ====>", error);
    return dispatch({
      type: SALARY_FAILED,
      payload: error?.message,
    });
  }
};

export const updateSalarySlip = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_SALARY_SLIP
  })
  try {
    let response = await api(`salary/updateSalarySlip/${id}`, 'put', data, getAuthHeader())
    console.log('update salary slip data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_SALARY_SLIP_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating salary slip error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_SALARY_SLIP_FAILED,
      payload: error?.message
    })
  }
}
// export const getSalarySlipDetails = () => async (dispatch) => {
//   dispatch({
//     type: SALARY_SLIP,
//   });
//   try {
//     let response = await api(`salary/getSalarySlipDetails`, "get", {}, getAuthHeader());
//     dispatch({
//       type: SALARY_SLIP_SUCCESS,
//       payload: response?.data,
//     });
//     return response;
//   } catch (error) {
//     console.log("while fetching Salary Slip details error ====>", error);
//     return dispatch({
//       type: SALARY_SLIP_FAILED,
//       payload: error?.message,
//     });
//   }
// };

// export const addSalary = (data) => async dispatch => {
//   dispatch({
//     type: ADD_SALARY
//   })
//   try {
//     let response = await api(`salary/add`, 'post', data, getAuthHeader())
//     console.log('add salary data', response);
//     toast.success("Added Successfully");
//     dispatch({
//       type: ADD_SALARY_SUCCESS,
//       payload: response?.data
//     })
//     return response
//   } catch (error) {
//     console.log("while Adding salary error ====>>>", error);
//     toast.error(error?.message);
//     return dispatch({
//       type: ADD_SALARY_FAILED,
//       payload: error?.message
//     })
//   }
// }

// export const updateSalary = (id, data) => async dispatch => {
//   dispatch({
//     type: UPDATE_SALARY
//   })
//   try {
//     let response = await api(`salary/update/${id}`, 'put', data, getAuthHeader())
//     console.log('update salary data', response);
//     toast.success("Updated Successfully");
//     dispatch({
//       type: UPDATE_SALARY_SUCCESS,
//       payload: response?.data
//     })
//     return response
//   } catch (error) {
//     console.log("while updating salary error ====>>>", error);
//     toast.error(error?.message);
//     return dispatch({
//       type: UPDATE_SALARY_FAILED,
//       payload: error?.message
//     })
//   }
// }


// export const getSalaryHistory = () => async (dispatch) => {
//   dispatch({
//     type: SALARY_HISTORY,
//   });
//   try {
//     let response = await api(`salary/getSalaryHistory`, "get", {}, getAuthHeader());
//     dispatch({
//       type: SALARY_HISTORY_SUCCESS,
//       payload: response?.data,
//     });
//     return response;
//   } catch (error) {
//     console.log("while fetching Salary history error ====>", error);
//     return dispatch({
//       type: SALARY_HISTORY_FAILED,
//       payload: error?.message,
//     });
//   }
// };

// export const addSalaryRevision = (data) => async dispatch => {
//   dispatch({
//     type: ADD_SALARY_REVISION
//   })
//   try {
//     let response = await api(`salary/addSalaryRevision`, 'post', data, getAuthHeader())
//     console.log('add salary revision data', response);
//     toast.success("Added Successfully");
//     dispatch({
//       type: ADD_SALARY_REVISION_SUCCESS,
//       payload: response?.data
//     })
//     return response
//   } catch (error) {
//     console.log("while Adding salary revision error ====>>>", error);
//     toast.error(error?.message);
//     return dispatch({
//       type: ADD_SALARY_REVISION_FAILED,
//       payload: error?.message
//     })
//   }
// }